var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconlyBoldVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 28.5,
    viewBox: "0 0 38 28.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Video",
    "data-name": "Iconly/Bold/Video",
    transform: "translate(-2 -4.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Video",
    transform: "translate(2 4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M18.82,0a7.429,7.429,0,0,1,7.815,7.716h0V20.784A7.429,7.429,0,0,1,18.82,28.5h-11A7.429,7.429,0,0,1,0,20.784H0V7.716A7.429,7.429,0,0,1,7.815,0h11Zm15.3,4.52a2.627,2.627,0,0,1,2.609.122A2.718,2.718,0,0,1,38,6.958h0V21.543a2.715,2.715,0,0,1-1.271,2.317,2.623,2.623,0,0,1-2.611.12h0L31.3,22.559a3.084,3.084,0,0,1-1.687-2.768h0V8.708A3.075,3.075,0,0,1,31.3,5.942h0Z",
    transform: "translate(0 0)",
    fill: "#729dd1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlyBoldVideo);
export default __webpack_public_path__ + "static/media/Iconly-Bold-Video.2490971c9f008fcc936e286786be8795.svg";
export { ForwardRef as ReactComponent };